/** Conteúdo opcional injetado pelas páginas de serviço: window.PL_PAGE_CONTENT */
export function getPageContent() {
  if (typeof window === "undefined") return null;
  const c = window.PL_PAGE_CONTENT;
  return c && typeof c === "object" ? c : null;
}
